// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1ayrv","buttons":"SendReceipts_buttons__3iZSC","email":"SendReceipts_email__2xm-n","bookApptTitle":"SendReceipts_bookApptTitle__3LlHx"};